import { render, staticRenderFns } from "./1-onboarding.vue?vue&type=template&id=02dc9a65&"
import script from "./1-onboarding.vue?vue&type=script&lang=js&"
export * from "./1-onboarding.vue?vue&type=script&lang=js&"
import style0 from "./1-onboarding.vue?vue&type=style&index=0&id=02dc9a65&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports